<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 基本参数 -->
        <el-tab-pane>
          <span slot="label">{{ $t("logs.dkim1") }}</span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 启用DKIM验证 -->

                  <td>{{ $t("logs.dkim1_a1") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-checkbox-group v-model="opendkim_sign">
                      <el-checkbox label=""></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.dkim1_a2')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 启用DKIM签名 -->

                  <td>{{ $t("logs.dkim1_a3") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-checkbox-group v-model="opendkim_verify">
                      <el-checkbox label=""></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.dkim1_a4')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                <tr>
                  <!-- 启用DMARC验证 -->

                  <td>{{ $t("logs.dkim1_a5") }}:</td>
                  <td style="display:flex; flex-direction:row">
                    <el-checkbox-group v-model="opendmarc_verify">
                      <el-checkbox label=""></el-checkbox>
                    </el-checkbox-group>
                    <el-alert
                      :title="$t('logs.dkim1_a6')"
                      type="warning"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                  </td>
                </tr>
                  <tr>
                  <!-- 动作 -->
                  <td>{{ $t("tab.spams29") }}:</td>
                  <td>
                    <el-select
                      v-model="dmarc_action"
                      placeholder="请选择"
                      size="mini"
                      
                    >
                      <el-option
                        v-for="item in dmarc_action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td style="display:flex;flex-direction:row">
                    <el-button type="primary" @click="save_sign_param()" :disabled="$root.jurisdiction.only_query==0">{{
                      $t("logs.save_a")
                    }}</el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-tab-pane>

        <!-- DKIM域名密钥 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.dkim2") }}</span>
          <div class="main">
            <el-button @click="tan_add_dkim()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.dkim1_a7") }}</el-button>
            <el-alert
              :title="this.dkim1_domain"
              type="warning"
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>

          <div class="switch1">
            <div class="table table_domain">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_domain"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="SIGN_DOMAIN"
                  :label="$t('logs.dkim1_a8')"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="KEY_SELECTOR"
                  :label="$t('logs.dkim1_a9')"
                  width="120"
                >
                </el-table-column>
                <el-table-column prop="KEY_VALUE" :label="$t('logs.dkim1_a10')">
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="150"
                >
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                    :disabled="$root.jurisdiction.only_query==0"
                      @click="del_ip(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_Upload' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_Upload"><span class="span_pad"></span> {{$t('logs.dkim1_a7')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.dkim1_a8") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="sign_domain" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.dkim1_a9") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="key_selector"
                      placeholder="选择器符号输入只能使用 _ - . 3个"
                    ></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sign_domain()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <!-- DKIM信任主机 -->
        <el-tab-pane label="DKIM信任主机">
          <span slot="label"> {{ $t("logs.dkim3") }}</span>
          <div class="main">
            <el-button @click="tan_trust_the_host()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.dkim1_a11") }}</el-button>
            <el-alert
              :title="this.dkim1_trust"
              type="warning"
              show-icon
              :closable="false"
            >
            </el-alert>
          </div>
          <div class="switch1">
            <div class="table">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_trust"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('logs.xuhao')"
                  width="60"
                >
                </el-table-column>
                <el-table-column
                  prop="SIGN_TRUST"
                  :label="$t('logs.dkim1_a12')"
                >
                </el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('logs.audit6')"
                  width="120"
                >
                  <template scope="scope">
                    <!-- 删除 -->
                    <el-button
                    :disabled="$root.jurisdiction.only_query==0"
                      @click="del_trust(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("table1.delete") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_relay_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_relay_domain"><span class="span_pad"></span> {{$t('logs.dkim1_a11')}}</div>
                        <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right:12px">
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="ipaddr" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sign_trust()" :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("logs.save_a")
                }}</el-button>
                <el-button type="danger" @click="tanSend()">{{
                  $t("logs.save_b")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
          <!-- LDAP收件人检查 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.ldap30") }}</span>
                <div class="main">
                    <p>
                        <span class="main_text"> {{ $t("logs.ldap31") }}:</span>
                        <el-select v-model="dmarc_dft_policy" placeholder="请选择">
                            <el-option v-for="item in dmarc_dft_policy_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button @click="save_ldap_check()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button>
                        <el-button @click="tan()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.ldap32") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table table_check">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList4" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')" width="100"> </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.smartLearn8')"> </el-table-column>
                            <el-table-column prop="SHOW_TYPE" :label="$t('logs.smtpIp6')"> </el-table-column>
                            <el-table-column prop="SHOW_ACTION" :label="$t('logs.Policy_list13')"> </el-table-column>
                            <el-table-column prop="address" :label="$t('logs.audit6')" width="160">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_ldap_list(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>
                                    <!-- 编辑 -->
                                    <el-button @click="edit_ldap_list(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.ditt") }}</el-button>
                                  
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu"  v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.ldap32')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                   ip/email:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="emailorip" placeholder=""></el-input>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择">
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.manage4") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="action" placeholder="请选择">
                                        <el-option v-for="item in action_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_ip()" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanOff()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                    <div class="pop-up" v-show="tanchu_ldap" v-drag>
                       

                        <el-row>
                            <el-button type="primary" @click="save_edit_ldap_list()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanOff_ldap()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_ldap"></div>
                    <div class="pop-up" v-show="tanchu_verify" v-drag="{ handle: '.pop_up_text_local_domain_edit' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain_edit"><span class="span_pad"></span> {{$t('logs.ldap32_edit')}}</div>
                        <p></p>
                       <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                   ip/email:
                                </div>
                                <div class="block block1">
                                     <span style="text-align:left;color:#0e2c5e">{{
                      this.emailorip
                    }}</span>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.smtpIp6") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="type" placeholder="请选择" disabled >
                                        <el-option v-for="item in type_arr" :key="item.value" :label="item.label" :value="item.value" >
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    <!-- 类型 -->

                                    {{ $t("logs.manage4") }} :
                                </div>
                                <div class="block block1">
                                    <el-select v-model="action" placeholder="请选择">
                                        <el-option v-for="item in action_arr" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_edit_verify_list()">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="tanOff_verify()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu_verify"></div>
                </div>
            </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      tanchu_ldap:false,
      emailorip:'',
      type:0,
      type_arr:[],
      action:1,
      action_arr:[],
      dmarc_dft_policy:'',
      dmarc_dft_policy_arr:[],
      dmarc_action:'',
      dmarc_action_arr:[],
tanchu_verify:false,
      dkim1_domain: "",
      dkim1_trust: "",
      ipaddr: "",
      sign_domain: "",
      key_selector: "",
      opendmarc_verify: "",
      opendkim_verify: "",
      opendkim_sign: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [
        {
          value: "选项1",
          label: "不使用TLS",
        },
        {
          value: "选项2",
          label: "增加信头标记",
        },
        {
          value: "选项3",
          label: "强制TLS",
        },
      ],
      checked: "",
      fileList_domain: [],
      fileList_trust: [],
      radio: [],
      data_loadok1: "",
      fileList4:[],
    };
  },
  mounted() {
    this.getFileList_load_sign_param();
    this.getFileList_load_sign_domain();
    this.getFileList_load_sign_trust();
    this.getFileList_check()
  },
  methods: {
    tan_trust_the_host(){
this.tanchu=true;
      this.ipaddr='';
    },
    tan_add_dkim(){
      this.tanchu=true,
      this.sign_domain='',
      this.key_selector=''
    },
    tanOff_verify(){
          this.tanchu_verify=false

    },
    edit_ldap_list(index, row) {
            console.log(index, row)
            this.emailorip=row.EMAIL
            this.action=row.ACTION
            this.type=row.TYPE
          this.tanchu_verify=true
    },
     del_ldap_list(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_dmarc_policy",
                        sid: sid,

                        emailorip: row.EMAIL,
                        type: row.TYPE

                    });
                    this.$axios
                        .post("/api/adm/cgi/newspam.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList_check()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
     save_ip() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: " save_dmarc_policy",
                sid: sid,

                type: this.type,
                action: this.action,
                newadd: 1,
                emailorip: this.emailorip,

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList_check()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
    // DMARC个性化策略编辑保存
     save_edit_verify_list() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            let str = this.$qs.stringify({
                __mode: " save_dmarc_policy",
                sid: sid,
                action: this.action,
                type: this.type,
                emailorip:this.emailorip,
                newadd:0

            });
            this.$axios
                .post("/api/adm/cgi/newspam.cgi", str)
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        this.$message({
                            type: "error",
                            message: `${res.data.fmstatus.errmsg}`,
                        });
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            type: "error",
                            message: `${res.data.fmstatus.errmsg}`,
                        });
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_verify = false
                        
                        this.getFileList_check()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
     // DMARC个性化策略加载
        getFileList_check() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            // console.log(this)
            // 获取表单数据,搜索条件

            // console.log(col, '5555')

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "load_dmarc_policy_cfg",
                        sid: sid,

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    console.log(res)
                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        this.$message({
                            type: "error",
                            message: `${res.data.fmstatus.errmsg}`,
                        });
                        this.loading=false
                    } else if (res.data.fmstatus.code == "2") {
                        this.$message({
                            type: "error",
                            message: `${res.data.fmstatus.errmsg}`,
                        });
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.fileList4 = res.data.ret.datalist;
                        this.dmarc_dft_policy_arr = res.data.ret.q_dmarc_dft_policy
                        this.dmarc_dft_policy = res.data.ret.dmarc_dft_policy
                        this.action_arr = res.data.ret.q_dmarc_dft_policy
                        this.type_arr = res.data.ret.q_type
                        this.show_hind4 = res.data.ret.LOAD_HINT

                        // 总条数

                        this.loading = false;

                    }
                })
               
        },
      // DMARC个性化 默认检查保存
        save_ldap_check() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

            this.$axios
                .get("/api/adm/cgi/newspam.cgi", {
                    params: {
                        __mode: "save_dmarc_dft_policy",
                        sid: sid,
                        dmarc_dft_policy: this.dmarc_dft_policy

                        // screen: "real_filterlog.html",
                    },
                })
                .then((res) => {
                    // console.log(res)
                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.getFileList_check()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })

        },
    save_sign_param() {
    this.$save_hint_test();
    this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_sign_param",
        sid: sid,
        // byad: this.byad == true ? 1 : 0,

        opendkim_sign: this.opendkim_sign == true ? 1 : 0,
        opendkim_verify: this.opendkim_verify == true ? 1 : 0,
        opendmarc_verify: this.opendmarc_verify == true ? 1 : 0,
        dmarc_action:this.dmarc_action,
        data_loadok: this.data_loadok1,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          this.$close_hint_test();
          this.$close_disable_hint_test();
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.getFileList_load_sign_param();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
     // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    // 基本参数
    getFileList_load_sign_param() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_sign_param",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.data_loadok1 = res.data.ret.ok;
            this.opendkim_sign =
              res.data.ret.result.opendkim_sign == 1 ? true : false;
            this.opendkim_verify =
              res.data.ret.result.opendkim_verify == 1 ? true : false;
            this.opendmarc_verify =
              res.data.ret.result.opendmarc_verify == 1 ? true : false;
              this.dmarc_action_arr=res.data.ret.result.q_dmarc_action
              this.dmarc_action=res.data.ret.result.dmarc_action
          }
        });
    },
    // 域名秘钥
    getFileList_load_sign_domain() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_sign_domain",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList_domain = res.data.ret.datalist;
            this.dkim1_domain = res.data.ret.LOAD_HINT;
            // console.log( this.dkim1_domain)
          }
        });
    },
    save_sign_domain() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_sign_domain",
        sid: sid,
        // byad: this.byad == true ? 1 : 0,

        sign_domain: this.sign_domain,
        key_selector: this.key_selector,
      });
      this.$axios
        .post(
          "/api/adm/cgi/newspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
    this.$close_hint_test();
    this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;
            this.loading = false;
            this.getFileList_load_sign_domain();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    del_ip(index, row) {
      // console.log(index, row)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_sign_domain",
            sid: sid,

            sign_domain: row.SIGN_DOMAIN,
          });
          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList_load_sign_domain();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // DKIM信任主机
    getFileList_load_sign_trust() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/aspam.cgi", {
          params: {
            __mode: "load_sign_trust",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList_trust = res.data.ret.datalist;
            this.dkim1_trust = res.data.ret.LOAD_HINT;
          }
        });
    },
    save_sign_trust() {
     this.$save_hint_test();
     this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      // console.log(col, '5555')
      let str = this.$qs.stringify({
        __mode: "save_sign_trust",
        sid: sid,
        // byad: this.byad == true ? 1 : 0,

        ipaddr: this.ipaddr,
      });
      this.$axios
        .post(
          "/api/adm/cgi/aspam.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.tanchu = false;
            this.loading = false;
            this.getFileList_load_sign_trust();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    del_trust(index, row) {
      // console.log(index, row)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          // console.log(sid);
          let str = this.$qs.stringify({
            __mode: "del_sign_trust",
            sid: sid,

            sign_trust: row.SIGN_TRUST,
          });
          this.$axios.post("/api/adm/cgi/aspam.cgi", str).then((res) => {
            // console.log(res)
            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "3") {
              // alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.getFileList_load_sign_trust();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 显示
    tan: function() {
      this.tanchu = true;
      this.emailorip=''
      this.action=1
      this.type=0
    },
    // 打开关闭
    tanSend: function() {
      this.tanchu = false;
    },
    tanOff: function() {
      this.tanchu = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .el-checkbox {
  margin-right: 8px;
}
/deep/ .table_domain .has-gutter th:nth-last-child(2) {
  text-align: center;
}

// 表格居中位置
/deep/ .table_domain .el-table__row td:last-child {
  text-align: center;
}
.main {
   
    border: 2px solid #D2D7E6;
    padding: 6px 0;
    padding-left: 10px;
}


.main_text {
    margin-right: 6px;
    color: #0e2c5e;
}
.main .el-select {
    margin-right: 6px
}
</style>
